module.exports = __webpack_public_path__ + "static/img/文创.b81c8ffd.png";